export default __webpack_public_path__ + "static/agent-mobile-real-5557e79c4c321fc67a047799f6df5900.png";